import React from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { hideElement } from 'utils';
import { VALIDATION_ERRORS } from 'components/forms/validation/enum';

export const ValidationError = ({ error }) => {
  const { t } = useTranslation();

  switch (error) {
    case VALIDATION_ERRORS.MANDATORY:
      return (
        <small className="form-text validation-error" style={hideElement(!error)}>
          * {t('this_is_a_mandatory_field')}
        </small>
      );
    default:
      return (
        <small className="form-text validation-error" style={hideElement(!error)}>
          {error}
        </small>
      );
  }
};

ValidationError.propTypes = {
  error: PropTypes.string,
};

ValidationError.defaultTypes = {
  error: 'Validation for this field failed.',
};
